//
//
//
//
//
//
//
//
//
//
//
//

import globalHelper from "../../mixins/globalHelper";
import { getProp, fromJsonString } from "@nuskin/ns-common-lib";

export default {
  filters: {
    currencyFilter(price, currencyLocale, currencyCode) {
      return globalHelper.methods.currencyFormatter(
        currencyLocale,
        "currency",
        currencyCode,
        price
      );
    }
  },
  mixins: [globalHelper],
  props: {
    product: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      default: () => null
    },
    salesEvents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      salesEvent: ""
    };
  },
  computed: {
    isSale() {
      return this.salesEvent !== "";
    },
    priceContainerClass() {
      return this.isSale ? "price__container--sale" : "price__container";
    },
    currencyLocale() {
      const { market, language } = globalHelper.methods.getMarketAndLanguage();
      return `${language}-${market.toUpperCase()}`;
    },
    currencyCode() {
      return this.variant.price.currencyCode;
    },
    variant() {
      return this.product.firstVariant;
    },
    isWholeSale() {
      return (
        this.user && (this.user.isDistributor || this.user.isPreferredCustomer)
      );
    },
    price() {
      const typeKey = this.isWholeSale ? "wholesale" : "retail";
      const regularPrice = this.variant.price[typeKey];

      let salePrice = null;
      if (this.isSale) {
        salePrice = this.variant.price[this.salesEvent][typeKey];
      }

      return {
        regularPrice,
        salePrice
      };
    }
  },
  watch: {
    salesEvents() {
      this.initSalesEvent();
    }
  },
  mounted() {
    this.initSalesEvent();
  },
  methods: {
    initSalesEvent() {
      if (!this.salesEvents) return;
      const pricing = fromJsonString(this.variant.pricingJson, {});

      let salesEvent = "";
      for (const activeSalesEvent of this.salesEvents) {
        const retailPrice = getProp(
          pricing,
          `retail.${activeSalesEvent}.price`,
          null
        );
        const wholesalePrice = getProp(
          pricing,
          `wholesale.${activeSalesEvent}.price`,
          null
        );

        if (retailPrice || wholesalePrice) {
          if (!wholesalePrice && this.isWholeSale) continue;
          if (!retailPrice && !this.isWholeSale) continue;

          this.variant.price[activeSalesEvent] = {
            retail: retailPrice,
            wholesale: wholesalePrice
          };

          salesEvent = activeSalesEvent;
        }
      }

      this.salesEvent = salesEvent;
    }
  }
};
